export enum adminRecruitmentCsvTypes {
    FETCH_ADMIN_RECRUITMENT_CSV_REQUEST = "FETCH_ADMIN_RECRUITMENT_CSV_REQUEST",
    FETCH_ADMIN_RECRUITMENT_CSV_SUCCESS = "FETCH_ADMIN_RECRUITMENT_CSV_SUCCESS",
    FETCH_ADMIN_RECRUITMENT_CSV_FAILURE = "FETCH_ADMIN_RECRUITMENT_CSV_FAILURE",
  }